import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';

@Injectable()
export class CompanyService {

  constructor(private http: HttpClient, private localStorageService: LocalStorageService ) { }

  public getBrands() {
    return this.http.get(`${environment.resource_api}companies/brands`,
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }

  public getVerticalFilters(ids: number[], id: number) {
    return this.http.post(`${environment.resource_api}filter/vertical`, {ids, car: id},
      {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }
}
